import { HomeService } from './services/home.service';
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  AfterContentChecked,
  AfterContentInit,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectorRef,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import 'zone.js';
import { MenuItemsComponent } from './components/menu-item/menu-items.component';
import { ResizableDrawerDirective } from './directives/resizable-drawer.directive';
//import { routes } from './routes';
import { SearchComponent } from './components/search/search.component';
import { TooltipEllipsisDirective } from './directives/tooltip-ellipsis.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FooterMenuComponent } from './components/footer-menu/footer-menu.component';
import { Subscription } from 'rxjs';
import { MobileToolbarComponent } from './components/mobile-toolbar/mobile-toolbar.component';
import { NoTranslateMaterialSymbolsDirective } from '../../shared/directives/noTranslateMaterialSymbols.directive';
import { ModalFormHomeComponent } from './components/modal-form-home/modal-form-home.component';
import { ModalFormHomeService } from './components/modal-form-home/service/modal-form-home.service';
import { HomeModalComponent } from './components/modal-home/modal-home.component';
import { NotificationsPanelComponent } from './components/notifications-panel/notifications-panel.component';
import { NotificationsService } from './components/notifications-panel/services/notifications.service';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ContentSkeletonComponent } from '../../shared/components/content-skeleton/content-skeleton.component';
@Component({
  selector: 'app-home',
  templateUrl: './home.page.component.html',
  styleUrls: ['./home.page.component.scss'],
  imports: [
    HomeModalComponent,
    ModalFormHomeComponent,
    NotificationsPanelComponent,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MenuItemsComponent,
    MatTooltipModule,
    ResizableDrawerDirective,
    RouterOutlet,
    FooterMenuComponent,
    MobileToolbarComponent,
    NoTranslateMaterialSymbolsDirective,
    CommonModule,
    ContentSkeletonComponent,
    NgxSkeletonLoaderModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageComponent implements OnInit, AfterViewInit {
  private readonly notificationsService = inject(NotificationsService);
  private readonly router = inject(Router);
  /** Id de la navegación que está mostrando el skeleton. Ignora cancelaciones viejas. */
  private pendingNavId: number | null = null;
  private settledPath = contentPath(this.router.url);
  readonly routeLoading = signal(false);
  /** `map` en 4SIG y Teledetección; el resto usa el skeleton de página. */
  readonly routeSkeleton = signal<'page' | 'map'>('page');

  private breakpointObserver = inject(BreakpointObserver);
  private homeService = inject(HomeService);
  private modalFormHomeService = inject(ModalFormHomeService);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild(ResizableDrawerDirective)
  drawerDirective!: ResizableDrawerDirective;
  @ViewChild('drawer') drawer!: MatDrawer;
  @ViewChild('toolbar') toolbar!: ElementRef<HTMLElement>;
  component!: any;
  name = 'Angular';
  enableOptions: [] = [];
  public filteredItems: any;
  public searchedItem: any;
  public appTruncateText: any;
  public menuSize: any;
  public firefox: boolean = false;
  closeOnClick: boolean = false;

  isExpanded = false; // Propiedad para manejar el estado desplegado/replegado
  public drawerMode: 'side' | 'over' = 'side';
  private expandedSubscription: Subscription;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      this.onRouteEvent(event);
    });
  }

  ngOnInit() {
    this.navegador();

    // ponytail: diferir del critical path del menú; ceiling = notif ~1–2s tarde
    const startPolling = () => this.notificationsService.startPolling();
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => startPolling(), { timeout: 2000 });
    } else {
      setTimeout(startPolling, 0);
    }

    this.expandedSubscription = this.homeService
      .getExpanded()
      .subscribe(value => {
        if (!this.isExpanded && value) {
          this.toggleDrawer();
        }
      });
    this.modalFormHomeService.drawerComponentHome.subscribe(
      (component: any) => {
        this.component = component;
        this.cdr.detectChanges(); // Forzar la detección de cambios después de asignar el componente
      }
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.handleResize();
      if (window.innerWidth < 1024) {
        this.drawer.close();
      }
    });
  }

  handleResize() {
    this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe(result => {
        this.drawerMode = result.matches ? 'over' : 'side';
        if (this.toolbar) {
          this.toolbar.nativeElement.style.display = result.matches
            ? 'block'
            : 'none';
        }
        if (this.drawer) {
          this.drawer.opened = !result.matches;
        }
      });
  }
  toggleDrawer() {
    this.isExpanded = !this.isExpanded;
    //const newWidth = this.isExpanded ? 210 : 100;
    this.menuSize = this.isExpanded ? 240 : 144;
    if (this.drawerDirective) {
      this.drawerDirective.sidenavWidth = this.menuSize; // Ajusta el tamaño del drawer
    }
    if (this.menuSize == 144) {
      this.homeService.setExpanded(false);
    }
  }

  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }
  isWebKit(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      (userAgent.indexOf('webkit') > -1 && userAgent.indexOf('chrome') > -1) ||
      userAgent.indexOf('safari') > -1
    );
  }
  navegador(): void {
    if (this.isFirefox()) {
      this.firefox = true;
    } else if (this.isWebKit()) {
      //this.webKit = true;
    }
  }

  closeMenu() {
    if (this.drawerMode === 'over') {
      this.drawer.close();
    }
  }

  private onRouteEvent(event: unknown): void {
    if (event instanceof NavigationStart) {
      if (contentPath(event.url) === this.settledPath) return;
      this.pendingNavId = event.id;
      this.routeSkeleton.set(
        isMapRoute(contentPath(event.url)) ? 'map' : 'page'
      );
      this.routeLoading.set(true);
      return;
    }

    if (event instanceof NavigationEnd) {
      this.settledPath = contentPath(event.urlAfterRedirects);
    }

    if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError ||
      event instanceof NavigationSkipped
    ) {
      if (event.id !== this.pendingNavId) return;
      this.pendingNavId = null;
      this.routeLoading.set(false);
    }
  }
}

function contentPath(url: string): string {
  return url.split(/[?#]/)[0];
}

function isMapRoute(path: string): boolean {
  return path === '/4sig' || path === '/teledeteccion';
}
